import { NAME } from './constants';

export default {
  FETCH: `${NAME}/FETCH`,
  FETCH_NEXT: `${NAME}/FETCH_NEXT`,
  FETCH_PREV: `${NAME}/FETCH_PREV`,
  FETCHING: `${NAME}/FETCHING`,
  FETCHED: `${NAME}/FETCHED`,
  REASSIGN: `${NAME}/REASSIGN`,
  REASSIGNED: `${NAME}/REASSIGNED`,
  FETCH_DRIVERS: `${NAME}/FETCH_DRIVERS`,
  FETCHED_DRIVERS: `${NAME}/FETCHED_DRIVERS`,
  MANUAL_DRIVER_SELECT: `${NAME}/MANUAL_DRIVER_SELECT`,
};
